import React from "react";

type Props = {
    name: string,
    description: string,
    icon: string,
    onConnect: () => {}
}

function ConnectItem({ name, description, icon, onConnect }: Props) {

    const handleOnConnect = (event: React.MouseEvent, callback: () => {}) => {
        event.preventDefault();
        callback();
    }

    return <>
        <div
            className="flex justify-center rounded-2.5xl border border-jacarta-100 bg-white py-4 px-7 transition-shadow hover:shadow-lg dark:border-transparent dark:bg-jacarta-700"
        >
            <figure className="mr-4 shrink-0">
                <a onClick={(e) => handleOnConnect(e, onConnect)} href="" className="relative block">
                    <img src={icon} width={"50px"} alt="avatar 1" className="rounded-2lg" loading="lazy" />
                </a>
            </figure>
            <div className="text-center ">
                <a onClick={(e) => handleOnConnect(e, onConnect)} href="" className="block">
                    <span className="font-display font-semibold text-jacarta-700 hover:text-accent dark:text-white">
                        {name}
                    </span>
                </a>
                <span className="text-sm dark:text-jacarta-300">{description}</span>
            </div>
        </div>
    </>
}

export default ConnectItem;